import React, { useState } from 'react'
import ExeatTypePill from '../../elements/ExeatTypePill'
import DeclineExeat from './DeclineExeat'
import ModalDialog from '../../layouts/ModalDialog'
import ApproveExeat from './ApproveExeat'
import moment from 'moment'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import StudentCheckOut from './StudentCheckOut'
import CancelExeat from './CancelExeat'
import ExtendExeat from './ExtendExeat'
import ChevronIcon from '../../elements/icons/ChevronIcon'

const ExeatCard = ({exeat, reload, openCheckIn}) => {
    const [approvingExeat, setApprovingExeat] = useState(false)
    const [decliningExeat, setDecliningExeat] = useState(false)
    const [cancelingExeat, setCancelingExeat] = useState(false)
    const [extendingExeat, setExtendingExeat] = useState(false)
    const [checkingOut, setCheckingOut] = useState(false)
    const [exeatExtensionsOpen, setExeatExtensionsOpen] = useState(false)

    return (
        <>
            <div className={`border rounded-[8px] w-full p-[20px] bg-opacity-50 mt-[20px]
                ${exeat?.approval?.status === 'pending' && 'bg-gray-100 border-gray-100'} 
                ${exeat?.approval?.status === 'approved' && 'bg-gray-100 border-green-400'} 
                ${exeat?.approval?.status === 'rejected' && 'bg-red-100 border-red-100'} 
            `}>
                <div className='w-full flex items-center justify-between pb-[10px] border-b border-gray-300'>
                    <p className={`font-space-grotesk font-[550] w-full capitalize 
                        ${exeat?.approval?.status === 'pending' && 'text-black'}
                        ${exeat?.approval?.status === 'approved' && 'text-green-600'}
                        ${exeat?.approval?.status === 'rejected' && 'text-red-600'} 
                    `}>Student Exeat {exeat?.approval?.status}</p>
                    <div className='w-1/2 flex flex-row-reverse gap-x-[5px]'>
                        <ExeatTypePill type={exeat?.reasonType} />
                        {exeat?.status === 'student-away' && <span className={`inline-block text-xs px-2 py-1 rounded bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize`}>Student currently away</span>}
                    </div>
                </div>

                <label className='uppercase block text-[10px] mt-[20px] tracking-[0.2em] mb-[5px]'>Exeat Note</label>
                <p className='text-sm mt-[5px]'>{exeat?.reason}</p>

                <p className='text-sm mt-[10px] text-gray-500'>From <span className='text-gray-900 font-space-grotesk'>{moment(exeat?.dates?.from).format('dddd, MMMM Do YYYY')}</span> to <span className='text-gray-900 font-space-grotesk'>{moment(exeat?.dates?.to).format('dddd, MMMM Do YYYY')}</span></p>

                <div>
                    <label className='uppercase block text-[10px] mt-[10px] tracking-[0.2em] mb-[5px]'>Pickup by</label>
                    <p className='text-sm mt-[5px]'>{exeat?.pickup?.name} ({exeat?.pickup?.phone}, {exeat?.pickup?.email})</p>
                </div>

                {exeat?.extensions?.length > 0 && 
                    <div className='w-full p-[10px] bg-gray-200 bg-opacity-70 rounded my-[10px]'>
                        <div className='w-full flex items-center justify-between'>
                            <p className='text-sm font-space-grotesk'>{exeat.extensions.length} Extensions</p>
                            <button onClick={()=>setExeatExtensionsOpen(!exeatExtensionsOpen)} className='flex items-center justify-center gap-x-[3px] text-sm font-space-grotesk font-[550]'>
                                {exeatExtensionsOpen ? 'Close' : 'Open'} Extensions
                                <ChevronIcon className={`w-4 h-4 ${exeatExtensionsOpen ? '-rotate-[270deg]' : '-rotate-90'} text-gray-600`} />
                            </button>
                        </div>
                        {exeatExtensionsOpen && <div className='w-full pt-[10px]'>
                            {exeat.extensions.map((extension, extensionIndex)=>(
                                <div key={extensionIndex} className='w-full flex items-start justify-between gap-x-[10px] my-[10px] border-b border-gray-400 py-[10px]'>
                                    <div className='w-8/12'>
                                        <label className='text-xs block mb-[5px] text-gray-500'>Remarks</label>
                                        <p className='text-sm'>{extension.remarks}</p>
                                        <p className='text-xs mt-[10px] text-gray-500'>Extended by {extension.extendedBy?.fullName}</p>

                                    </div>
                                    <div className='w-2/12'>
                                        <p className='text-sm text-gray-500'>Extended for {extension.days} days to <span className='text-black font-space-grotesk font-[550]'>{moment(extension.newResumptionDate).format('DD/MM/YYYY')}</span></p>
                                    </div>
                                    <div className='w-2/12'>
                                        <p className='text-sm text-gray-500'>Extended {moment(extension.date).format('DD/MM/YYYY')}</p>
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </div>
                }

                <div className='w-full flex items-end justify-between mt-[20px] border-t border-gray-300'>
                    <div>
                        <label className='uppercase block text-[10px] mt-[20px] tracking-[0.2em] mb-[5px]'>Created by</label>
                        <p className='text-sm mt-[5px]'>{exeat?.createdBy?.name}</p>
                    </div>

                    <div className='flex flex-row-reverse gap-x-[5px]'>
                        {exeat?.approval?.status === 'pending' && <button onClick={()=>{setApprovingExeat(true)}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-green-200 flex items-center justify-center gap-x-[5px]'>
                            Approve Exeat
                        </button>}
                        {exeat?.approval?.status === 'pending' && <button onClick={()=>{setDecliningExeat(true)}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-gray-200 flex items-center justify-center gap-x-[5px]'>
                            Decline Exeat
                        </button>
                        }
                        {exeat?.approval?.status === 'approved' && exeat?.status !== 'student-away' && <button onClick={()=>{setCheckingOut(true)}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-green-200 flex items-center justify-center gap-x-[5px] text-green-800 bg-opacity-50 transition duration-200 hover:bg-opacity-90'>
                            Checkout Student <ArrowIcon className={`w-4 h-4`} />
                        </button>}
                        {exeat?.approval?.status === 'approved' && exeat?.status === 'student-away' && <button onClick={()=>{openCheckIn()}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-green-200 flex items-center justify-center gap-x-[5px] text-green-800 bg-opacity-50 transition duration-200 hover:bg-opacity-90'>
                            Check-in Student <ArrowIcon className={`w-4 h-4`} />
                        </button>}
                    
                        {exeat?.approval?.status === 'approved' && exeat?.status !== 'student-away' && <button onClick={()=>{setCancelingExeat(true)}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-red-200 flex items-center justify-center gap-x-[5px] text-red-800 bg-opacity-50 transition duration-200 hover:bg-opacity-90'>
                            Cancel Exeat
                        </button>}
                        {exeat?.approval?.status === 'approved' && exeat?.status === 'student-away' && <button onClick={()=>{setExtendingExeat(true)}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-gray-300 border flex items-center justify-center gap-x-[5px] bg-opacity-60 transition duration-200 hover:bg-opacity-90'>
                            Extend Exeat
                        </button>}
                    </div>
                </div>
            </div>

            <ModalDialog
                shown={approvingExeat} 
                closeFunction={()=>{setApprovingExeat(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Approve exeat for this student'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <ApproveExeat exeat={exeat} close={()=>{setApprovingExeat(false)}} reload={()=>{reload()}} />
            </ModalDialog>

            <ModalDialog
                shown={decliningExeat} 
                closeFunction={()=>{setDecliningExeat(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Decline exeat for this student'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <DeclineExeat exeat={exeat} close={()=>{setDecliningExeat(false)}} reload={()=>{reload()}} />
            </ModalDialog>

            <ModalDialog
                shown={checkingOut} 
                closeFunction={()=>{setCheckingOut(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Check-out this student'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <StudentCheckOut exeat={exeat} close={()=>{setCheckingOut(false)}} reload={()=>{reload()}} />
            </ModalDialog>

            <ModalDialog
                shown={cancelingExeat} 
                closeFunction={()=>{setCancelingExeat(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Cancel this exeat'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <CancelExeat exeat={exeat} close={()=>{setCancelingExeat(false)}} reload={()=>{reload()}} />
            </ModalDialog>

            <ModalDialog
                shown={extendingExeat} 
                closeFunction={()=>{setExtendingExeat(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Extend this exeat'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <ExtendExeat close={()=>{setExtendingExeat(false)}} reload={()=>{reload()}} exeat={exeat}  />
            </ModalDialog>
        </>
    )
}

export default ExeatCard